//
import type { FAQ } from '@/types/Models/FAQ'
import type { FAQStoreState } from '@/types/Store'
import { defineStore } from 'pinia'
import FAQProxy from '@/proxies/FAQProxy'

export const useFaqStore = defineStore('faq', {
  state: (): FAQStoreState => ({
    question: {
      question: '',
      answer: '',
    },
    questions: [],
  }),
  actions: {
    fetchQuestions() {
      return new FAQProxy().all().then((response) => {
        this.questions = response.data
        return response
      })
    },
    createQuestion(data: FAQ) {
      return new FAQProxy().create(data).then(() => this.fetchQuestions())
    },
    fetchQuestion(id: string) {
      return new FAQProxy().find(id).then((response) => {
        this.question = response.data
        return response.data
      })
    },
    deleteQuestion(id: string) {
      return new FAQProxy().destroy(id).then(() => this.fetchQuestions())
    },
    updateQuestion({ id, data }: { id: string; data: FAQ }) {
      return new FAQProxy().update(id, data).then(() => this.fetchQuestions())
    },
  },
})

export type FaqStore = ReturnType<typeof useFaqStore>
